import React from 'react';
import {Button, Dimmer, Loader, Segment, Form} from 'semantic-ui-react';
import {TextBoxField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {Alert} from 'componentLibrary';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import ApiActions from 'go/actions/api';
import {Link} from 'react-router-dom';
import {API_AUTH_LOGIN_SUCCESS} from 'common/types';
import AccountWrapper from 'go/pages/account/AccountWrapper';
import {CreatePasswordForm} from 'app-ui-componentlibrary';
import queryString from 'query-string';
import {checkIfValuesAre} from 'common/utils';
import PhoneNumberList from 'go/components/profile/phoneNumberList';
import {validatePhoneNumber} from 'common/utils';
import {Toggle} from 'componentLibrary';
import _ from 'lodash';
import REST from 'go/requests/rest';

const isRequired = (val) => {
  return !checkIfValuesAre([undefined, null, ''], val);
};

const errorMapping = {
  firstName: {
    test: isRequired,
    msg: 'Please enter your first name',
  },
  lastName: {
    test: isRequired,
    msg: 'Please enter your last name',
  },
};

// after application is submitted and email link clicked, go here to fill in account information
// and password
export class UnauthAccount extends React.Component {
  constructor(props) {
    super(props);
    let phoneNumbers;
    this.state = {
      firstName: '',
      lastName: '',
      password: '',
      phoneNumbers: undefined,
      confirmation: '',
      email: '',
      token: '',
      formHasErrors: true,
      formHasPassErrors: true,
      backendErrorMsg: false,
      loading: true,
      validToken: false,
      blurred: {
        firstName: false,
        lastName: false,
      },
    };
  }

  componentDidMount() {
    const loginGovIntegrationPWDRemoval = _.includes(
      this.props.toggles,
      'passwordRemovalLoginGovIntegration'
    );

    if (loginGovIntegrationPWDRemoval) {
      this.props.loginFailure();
    }
  }

  UNSAFE_componentWillMount() {
    const parsed = queryString.parse(this.props.location.search);
    const token = parsed.token;
    const email = parsed.email ? parsed.email.toLowerCase() : parsed.email;
    this.setState({
      email,
      token,
    });
    REST.registration
      .confirmRegistration(token, email)
      .then((response) => {
        if (response.ok) {
          this.setState({error: false, validToken: true, loading: false});
        } else {
          this.setState({error: true, validToken: false, loading: false});
        }
      })
      .catch((error) => {
        this.setState({error: true, validToken: false, loading: false});
      });
  }

  componentDidUpdate() {
    if (
      _.includes(this.props.toggles, 'regPhone') &&
      _.isEmpty(this.state.phoneNumbers)
    ) {
      this.setState({
        phoneNumbers: [
          {
            id: 0,
          },
        ],
      });
    }
  }

  handleSubmit = (e) => {
    let response;
    let action;

    if (this.props.createNewPass) {
      response = this.props.completeAccount(
        this.state.email,
        this.state.password,
        this.state.firstName,
        this.state.lastName,
        this.state.phoneNumbers,
        this.state.token
      );
    } else {
      response = this.props.updatePW(
        this.state.email,
        this.state.password,
        this.state.token
      );
    }
    response
      .then((res) => {
        this.handleResponseFromServer(res);
      })
      .catch((err) => {
        this.handleErrorFromServer(err);
      });
  };

  handleResponseFromServer = (res, password) => {
    if (res !== undefined) {
      if (res.type === API_AUTH_LOGIN_SUCCESS) {
        this.handleLoginAttempt();
      } else {
        this.handleErrorFromServer(res);
      }
    } else {
      this.handleErrorFromServer();
    }
  };

  handleErrorFromServer = (err) => {
    let msg = undefined;
    if (err !== undefined) {
      msg = _.get(err, 'payload.response.error');
      if (msg === undefined) {
        msg = _.get(err, 'message');
      }
    }
    if (msg === undefined) {
      msg =
        'There has been an unexpected error. If you continue to receive this message please contact FEMA for support.';
    }
    this.setState({
      backendErrorMsg: msg,
    });
  };

  handleLoginAttempt = () => {
    this.props.loginAttempt(this.state.email, this.state.password).then((res) => {
      if (res !== undefined && res.type === API_AUTH_LOGIN_SUCCESS) {
        this.props.loginSuccess();
      } else {
        this.props.loginFailure();
      }
    });
  };

  getErrorMessageForField(fieldName) {
    // if it passes the test, no errors
    if (!errorMapping[fieldName].test(this.state[fieldName])) {
      return errorMapping[fieldName].msg;
    } else {
      return '';
    }
  }

  handlePasswordErrors = (hasErrors) => {
    if (this.state.formHasPassErrors !== hasErrors) {
      this.setState({
        formHasPassErrors: hasErrors,
      });
    }
  };

  handleChange = (name, value) => {
    this.setState(
      () => {
        let stateToMerge = {};
        stateToMerge[name] = value;
        return stateToMerge;
      },
      () => {
        let phoneNumbers = this.state.phoneNumbers;
        let phoneErrors = false;
        if (_.includes(this.props.toggles, 'regPhone')) {
          _.forEach(phoneNumbers, (number) => {
            // also mutates phone records with errors...
            phoneErrors = phoneErrors || validatePhoneNumber(number);
          });
        }
        const firstNameErrors = this.getErrorMessageForField('firstName');
        const lastNameErrors = this.getErrorMessageForField('lastName');
        this.setState({
          phoneNumbers,
          formHasErrors: firstNameErrors || lastNameErrors || phoneErrors,
        });
      }
    );
  };

  handleBlur = (name, value) => {
    let newBlurred = Object.assign({}, this.state.blurred);
    newBlurred[name] = true;
    this.setState({
      blurred: newBlurred,
    });
  };

  renderNewPassForm = () => {
    const {firstName, lastName, password, confirmation, blurred} = this.state;
    const firstNameErrors = this.getErrorMessageForField('firstName');
    const lastNameErrors = this.getErrorMessageForField('lastName');
    return (
      <Form error>
        <Form.Field>
          <TextBoxField
            value={firstName}
            label="First Name"
            id="firstName"
            title={'Required: First Name'}
            name="firstName"
            displayError={blurred.firstName && firstNameErrors}
            handleChange={(e, data) => {
              this.handleChange(data.name, _.trim(data.value));
            }}
            handleBlur={(e) => {
              const {name, value} = e.target;
              this.handleBlur(name, value);
            }}
            maxLength={101}
            errorMessages={blurred.firstName && firstNameErrors}
          />
        </Form.Field>
        <Form.Field>
          <TextBoxField
            value={lastName}
            label="Last Name"
            id="lastName"
            title={'Required: Last Name'}
            name="lastName"
            displayError={blurred.lastName && lastNameErrors}
            handleChange={(e, data) => {
              this.handleChange(data.name, _.trim(data.value));
            }}
            handleBlur={(e) => {
              const {name, value} = e.target;
              this.handleBlur(name, value);
            }}
            maxLength={101}
            errorMessages={blurred.lastName && lastNameErrors}
          />
        </Form.Field>
        <Toggle toggle="regPhone">
          <PhoneNumberList
            handleChange={(e, data) => {
              this.handleChange(data.name, data.value);
            }}
            phoneNumbers={this.state.phoneNumbers}
            handlePhoneOnBlur={() => {}}
          />
        </Toggle>
        <CreatePasswordForm
          handleChange={this.handleChange}
          password={password}
          confirmation={confirmation}
          handlePasswordErrors={this.handlePasswordErrors}
        />
      </Form>
    );
  };

  renderUpdatePassForm = () => {
    const {password, confirmation} = this.state;
    return (
      <CreatePasswordForm
        handleChange={this.handleChange}
        password={password}
        confirmation={confirmation}
        handlePasswordErrors={this.handlePasswordErrors}
      />
    );
  };

  render() {
    const {createNewPass} = this.props;
    const innerForm = createNewPass
      ? this.renderNewPassForm()
      : this.renderUpdatePassForm();
    const createPWDisabled = this.state.formHasPassErrors || this.state.formHasErrors;
    const createPWText = {
      pageTitle: 'Account Creation',
      pageGuidance: '',
    };
    const updatePWDisabled = this.state.formHasPassErrors;
    const updatePWText = {
      pageTitle: 'Reset your password',
      pageGuidance: 'Please enter a new password below.',
    };
    const disabledSubmit = createNewPass ? createPWDisabled : updatePWDisabled;
    const text = createNewPass ? createPWText : updatePWText;
    const backToText = createNewPass ? 'Register' : 'Reset Password';
    const backToLink = createNewPass ? '/register' : '/requestPasswordReset';
    return (
      <React.Fragment>
        <AccountWrapper
          title={text.pageTitle}
          guidance={text.pageGuidance}
          confirmAction={this.handleSubmit}
          cancelAction={this.props.loginFailure}
          disabled={disabledSubmit}
          showNav={!this.state.loading && this.state.validToken}
          buttonText="Submit"
        >
          {this.state.error && (
            <Alert
              header="Unable to validate your token"
              type="error"
              dismissable={false}
            >
              <div>
                <p>
                  We were unable to validate your token. It's possible that your token has
                  expired. Please use the link below to obtain a new token.
                </p>
                <div style={{textAlign: 'center'}}>
                  <Button negative as={Link} to={backToLink}>
                    {backToText}
                  </Button>
                </div>
              </div>
            </Alert>
          )}
          {this.state.loading && (
            <Dimmer.Dimmable as={Segment} basic>
              <Dimmer inverted active>
                <Loader indeterminate>Validating your token...</Loader>
              </Dimmer>
            </Dimmer.Dimmable>
          )}
          {!this.state.loading && this.state.validToken && innerForm}
          {this.state.backendErrorMsg && (
            <Alert type="error" dismissable={false}>
              <p>{this.state.backendErrorMsg}</p>
            </Alert>
          )}
        </AccountWrapper>
      </React.Fragment>
    );
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    completeAccount: (username, password, firstName, lastName, phoneNumbers, token) => {
      const action = ApiActions.auth.completeAccount(
        username.toLowerCase(),
        password,
        firstName,
        lastName,
        phoneNumbers,
        token
      );
      const response = dispatch(action);
      return response;
    },
    updatePW: (username, password, token) => {
      const action = ApiActions.auth.updatePW(username.toLowerCase(), password, token);
      const response = dispatch(action);
      return response;
    },
    loginAttempt: (username, password) => {
      const action = ApiActions.auth.login(username.toLowerCase(), password);
      const response = dispatch(action);
      return response;
    },
    loginSuccess: () => {
      dispatch(push('/'));
    },
    loginFailure: () => {
      dispatch(push('/login'));
    },
  };
};

export const mapStateToProps = (state) => {
  return {
    toggles: _.get(state, 'toggles.toggles'),
  };
};

export const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(UnauthAccount);
